import React from "react";
import { useParams, Link } from "react-router-dom";

const Service = () => {
  const { serviceId } = useParams(); // ← fetch URL slug

  // ---------- SERVICE CONTENT DATA ----------
  const serviceData = {
    taxation: {
      title: "Taxation Services",
      img: "../assets/img/tax.png",
      desc: [
        "We simplify your finances with expert tax planning, ITR filing, GST, and compliance management.",
        "Our team ensures accuracy, maximum savings, and complete support for businesses and individuals.",
        "From monthly filings to annual returns — we handle everything professionally and on time."
      ],
      points: [
        "GST Registration & Filing",
        "ITR Filing for Individuals & Businesses",
        "Tax Planning & Compliance",
        "Expert Guidance Anytime"
      ],
    },

    loans: {
      title: "Loan Solutions",
      img: "../assets/img/loans.png",
      desc: [
        "We help businesses and individuals get fast, reliable funding with minimum documentation.",
        "Our transparent loan processing ensures smooth approval and quick disbursement.",
        "From business loans to personal loans — we cover all segments."
      ],
      points: [
        "Fast Approval Process",
        "Low Documentation",
        "Multiple Loan Options",
        "Dedicated Loan Experts"
      ],
    },

    digital: {
      title: "Digital Marketing",
      img: "../assets/img/digi.png",
      desc: [
        "Boost your online presence with result-driven digital marketing strategies.",
        "We help businesses generate quality leads through SEO, ads, and social media strategies.",
        "Grow your brand through targeted campaigns and analytics-driven execution."
      ],
      points: [
        "Lead Generation Campaigns",
        "SEO & Website Ranking",
        "Social Media Growth",
        "Performance Tracking"
      ],
    },

    recruitment: {
      title: "Recruiting & Staffing",
      img: "../assets/img/hr.png",
      desc: [
        "Build a strong and efficient team with our professional staffing solutions.",
        "We connect the right talent with the right opportunity using proven hiring methods.",
        "Hire smarter, faster, and more effectively."
      ],
      points: [
        "Skilled Talent Pool",
        "Fast Hiring Support",
        "Pre-Screened Candidates",
        "Dedicated HR Team"
      ],
    },
  };

  // If invalid route
  if (!serviceData[serviceId]) {
    return (
      <div className="container py-5 text-center">
        <h2>Service Not Found</h2>
        <Link to="/services" className="btn btn-primary mt-3">
          Back to Services
        </Link>
      </div>
    );
  }

  const s = serviceData[serviceId];

  return (
    <div className="container-fluid py-5 wow fadeInUp" data-wow-delay="0.1s">
      <div className="container py-5">

        <Link 
          to="/services"
          className="btn btn-outline-primary mb-4"
          style={{ fontSize: "16px" }}
        >
          ← Back to Services
        </Link>

        <div className="row g-5">

          {/* Left Column */}
          <div className="col-lg-7">
            <div className="section-title position-relative pb-3 mb-5">
              <h5 className="fw-bold text-primary text-uppercase">{s.title}</h5>
              <h1 className="mb-0">{s.title}</h1>
            </div>

            {s.desc.map((p, index) => (
              <p key={index} className="mb-4">{p}</p>
            ))}

            <div className="row g-0 mb-3">
              {s.points.map((point, i) => (
                <div className="col-sm-6 wow zoomIn" data-wow-delay="0.2s" key={i}>
                  <h5 className="mb-3">
                    <i className="fa fa-check text-primary me-3"></i> {point}
                  </h5>
                </div>
              ))}
            </div>

            <Link to="/contact" className="btn btn-primary py-3 px-5 mt-3">
              Contact Us
            </Link>

          </div>

          {/* Right Column - Image */}
          <div className="col-lg-5" style={{ minHeight: "500px" }}>
            <div className="position-relative h-100">
              <img
                className="position-absolute w-100 h-100 rounded wow zoomIn"
                data-wow-delay="0.9s"
                src={s.img}
                alt={s.title}
                style={{ objectFit: "cover" }}
              />
            </div>
          </div>

        </div>
      </div>
    </div>
  );
};

export default Service;
